import styled from 'styled-components';
import shadow from '../../assets/images/shadow.png';

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.75);
`;

const StyledShadow = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 1920px;
	height: 1080px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export { StyledBackground, StyledShadow };
